import React, {useState} from 'react'
import MobileUserSettings from './settings/MobileUserSettings'
import MobileTradeSettings from "./settings/MobileTradeSettings"

function MobileSettings() {
  const [selectedTab, setSelectedTab] = useState("my_targets")
  return (
    <div className='mobile_container'>
       <ul className="mobile_tab_nav">
          <li className={selectedTab === "my_targets" ? "active_widget_tab li": "li"} onClick={()=> setSelectedTab("my_targets")}><span>My Targets </span></li>
          <li className={selectedTab === "trade_settings" ? "active_widget_tab li": "li"}  onClick={()=> setSelectedTab("trade_settings")}><span>Trade Settings</span></li>
      </ul>

      { renderTabContent(selectedTab)}
    </div>
  )
}

export default MobileSettings

function renderTabContent(selectedTab) {
  switch (selectedTab) {
      case 'my_targets':
          return <MobileUserSettings />;
      case 'trade_settings':
          return <MobileTradeSettings />;
      
      default:
          return null;
  }
}